<template>
  <v-app>
    <v-container fluid class="docs mt-4">
      <v-row justify="space-between">
        <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
            <tr>
              <td><div align="left"><h4><b>Privacy Policy</b></h4></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                This Privacy Policy describes how Loi Hein ("we", "us", or "our") collects, uses, and shares personal information when you use our Facebook application (the "App").
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>Information We Collect</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                When you use the App, we may collect certain information automatically, including:
                <ul>
                  <li>Facebook Information: We may collect information that you have made available to us through your Facebook account, such as your name, profile picture, gender, and other information that is part of your Facebook profile.</li>
                  <li>Usage Information: We may collect information about your interactions with the App, such as the features you use, the actions you take, and the time, frequency, and duration of your activities.</li>
                  <li>Device Information: We may collect information about the device you use to access the App, including the device type, operating system, unique device identifiers, and mobile network information.</li>
                  <li>Log Data: We may automatically collect log information when you use the App, including your IP address, browser type, referring/exit pages, and the pages you view.</li>
                </ul>
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>How We Use Your Information</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                When you use the App, we may collect certain information automatically, including:
                <ul>
                  <li>With service providers who help us provide, maintain, and improve the App;</li>
                  <li>With third parties as required by law or to protect our rights;</li>
                  <li>With affiliates and business partners for their own marketing purposes, unless you opt out;</li>
                  <li>With your consent or at your direction;</li>
                </ul>
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>Your Choices</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                You may have certain choices regarding the information we collect and how it is used:
                <ul>
                  <li>You can access and update certain information by logging into your Facebook account and adjusting your privacy settings;</li>
                  <li>You can opt out of receiving promotional communications from us by following the instructions in those communications; and</li>
                  <li>You can contact us using the information provided below to request access to or deletion of your personal information.</li>
                </ul>
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>Data Security</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                We take reasonable measures to protect the security of your information, but please be aware that no method of transmission over the internet or method of electronic storage is completely secure.
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>Changes to Our Policy</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the "Last Updated" date at the top of the page will be revised accordingly.              
              </b></div></td>
            </tr>
            <tr>
              <td><div align="left" style="margin-top: 25px;"><h5><b>Contact Us</b></h5></div></td>
            </tr>
            <tr>
              <td><div align="left"><b>
                If you have any questions or concerns about this Privacy Policy, please contact us at info@loiheinco.com.
              </b></div></td>
            </tr>
          </table>
        </v-row>
    </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'Login',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  computed: {
  },

  watch: {

  },
  async created() {

  },
  async updated() {

  },
}

</script>

<style src="./Policy.scss" lang="scss"/>
